import { USUARIO_ORIGEN_BDE } from "common/constants"
import { removeMimeFromBase64 } from "common/utils/formats"
import { toAlphaNumerics } from "common/utils/utils"

const prepareConceptos = (
  conceptos: $TSMigrationFixMe,
  sinValorar: $TSMigrationFixMe
) => {
  return conceptos.map((concepto: $TSMigrationFixMe) => ({
    articulo: {
      concepto: concepto.concepto,
      precioVenta: sinValorar ? null : concepto.precioVenta,
      tipoArticulo: 1,
    },

    impuestoEmpresaRepercutidoId: concepto.impuestoRepercutidoId,
    cantidad: concepto.cantidad,
    tarifaImpuesto: concepto.tarifaImpuesto,
  }))
}

const prepareUserData = (user: $TSMigrationFixMe) => ({
  cif: toAlphaNumerics(user?.nif),

  direccion: {
    calle: user?.direccion,
    codigoPostal: user?.cp,
    poblacionId: user?.poblacionId,
    poblacionExtranjera: user?.poblacionExtranjera,
  },

  email: user?.email,
  razonSocial: user?.razonSocial,
  telefono: user?.telefono,
})

const mapFacturaRecurrenteToPost = (
  documento: $TSMigrationFixMe,
  sinValorar: $TSMigrationFixMe,
  observacionCesion: $TSMigrationFixMe,
  cuentaContable = null
) => {
  const files = [...(documento.archivosAdjuntos || [])]

  if (documento.logo) {
    files.push({
      fileAsBase64: removeMimeFromBase64(documento.logo),
      tipo: 2,
    })
  }

  return {
    tipoDocumento: 2,
    documentosComercialesAsociadosIds: documento.documentosAsociadosId,
    articulosDocumento: prepareConceptos(documento.conceptos, sinValorar),
    cliente: prepareUserData(documento.cliente),
    proveedor: prepareUserData(documento.usuario),
    libradorId: documento.usuario?.id,
    libradoId: documento.cliente?.id,
    observaciones: observacionCesion
      ? `${observacionCesion}\n${documento.observaciones || ""}`
      : documento.observaciones || null,
    serie: documento.serie,
    ficheros: files,
    configuracion: {
      color: documento.codigoHex,
    },
    fechaOperacion: documento.fechaOperacion
      ? new Date(documento.fechaOperacion)
      : null,
    ImpuestoEmpresaRetenidoId: sinValorar ? null : documento.impuestoRetenidoId,
    impuestoRetenido: documento.impuestoRetenido,
    tarifaImpuesto: sinValorar ? null : documento.tarifaImpuesto,
    descuento: sinValorar ? null : documento.descuento,
    diasPago: sinValorar ? null : documento.diasPago,
    divisa: documento.divisa,
    fechaEmision: new Date(documento.fechaEmision),
    formaPago: documento.formaPago,
    importe: sinValorar ? null : documento.importe,
    emailLibrado: documento.cliente?.email,
    usuarioOrigen: documento.usuarioOrigen || USUARIO_ORIGEN_BDE,
    cuentaContableCategoriaId: cuentaContable,
    intervalo: documento.intervalo,
    fechaFin: documento.fechaFin,
    fechaInicio: documento.fechaInicio,
    logo: files?.[0],
  }
}

export default mapFacturaRecurrenteToPost
